import React from "react";
import { AlertTriangle } from "lucide-react";
import { Requirement, Status } from "../../redux/interfaces/folder.types.ts";
import { InvalidReasonDisplay } from "./ui/InvalidReasonDisplay.tsx";

interface Props {
  requirement: Requirement;
}

export const InvalidRequirementReason: React.FC<Props> = ({ requirement }) => {
  if (!requirement) return null;

  const { invalid_reason, status } = requirement;

  if (!invalid_reason || status !== Status.Invalid) return null;

  return (
    <div className="w-full rounded-lg border border-amber-200 bg-amber-50 px-4 py-3 mb-6">
      <div className="flex items-start gap-3">
        <AlertTriangle className="h-4 w-4 text-amber-500 mt-0.5 flex-shrink-0" />
        <div className="text-sm text-amber-800">
          <span className="font-semibold">Requisito rechazado: </span>
          <InvalidReasonDisplay reason={invalid_reason} />
        </div>
      </div>
    </div>
  );
};
